import {useReversalService} from '../../service/reversal/index'

const useUploadFaq = () => {
    const {updateFaqByUpload} = useReversalService()
  const uploadFaq = async (data: any) => {
    const res = await updateFaqByUpload(data);
    return res; // Return the response

     };
  return {
    uploadFaq,
  };
};

export default useUploadFaq;
